import React from 'react'
import { LoggedOutContainer, MessageStyled } from './LoggedOut.styles'
import { showLogin } from '@core/Areas/Login/helpers'
import { LockIcon } from '@core/Areas/VenueMode/Components/Shared/LockIcon'
import { VenueModeButton } from '@core/Areas/VenueMode/Components/Shared/VenueModeButton'
import { VENUE_FEATURE_NAME } from '@core/Areas/VenueMode/constants'

export const LoggedOut = (): React.JSX.Element => {
  return (
    <LoggedOutContainer>
      <LockIcon />
      <MessageStyled>{`Please log in to view ${VENUE_FEATURE_NAME}`}</MessageStyled>
      <VenueModeButton onClick={() => showLogin()}>Log in / Join</VenueModeButton>
    </LoggedOutContainer>
  )
}
